import * as types from './mutation-types';
import * as actions from './actions';

const state = {
	productionScheduleData: {},
	productionScheduleDataError: {},
	productionScheduleDataLoading: false,
	savedProductionSchedule: {},
	saveProductionScheduleError: '',
	saveProductionScheduleLoading: false,
	productionScheduleHistory: [],
	getProductionScheduleHistoryError: {},
	getProductionScheduleHistoryLoading: false,
	savedProductionScheduleHistoryOnDynamoDB: {},
	saveProductionScheduleHistoryOnDynamoDBError: {},
	saveProductionScheduleHistoryOnDynamoDBLoading: false,
	deletedProductionScheduleHistoryOnDynamoDB: {},
	deleteProductionScheduleHistoryOnDynamoDBError: {},
	deleteProductionScheduleHistoryOnDynamoDBLoading: false,
	reloadProductionScheduleHistory: {},
	reloadProductionScheduleHistoryError: {},
	reloadProductionScheduleHistoryLoading: false,
	deletedProductionSchedule: {},
	deleteProductionScheduleError: {},
	deleteProductionScheduleLoading: false,
	scheduleResult: {},
	scheduleError: {},
	scheduleLoading: false
}

const getters = {
	productionScheduleData: state => state.productionScheduleData,
	productionScheduleDataError: state => state.productionScheduleDataError,
  	productionScheduleDataLoading: state => state.productionScheduleDataLoading,
  	savedProductionSchedule: state => state.savedProductionSchedule,
	saveProductionScheduleError: state => state.saveProductionScheduleError,
  	saveProductionScheduleLoading: state => state.saveProductionScheduleLoading,
  	productionScheduleHistory: state => state.productionScheduleHistory,
	getProductionScheduleHistoryError: state => state.getProductionScheduleHistoryError,
  	getProductionScheduleHistoryLoading: state => state.getProductionScheduleHistoryLoading,
  	savedProductionScheduleHistoryOnDynamoDB: state => state.savedProductionScheduleHistoryOnDynamoDB,
	saveProductionScheduleHistoryOnDynamoDBError: state => state.saveProductionScheduleHistoryOnDynamoDBError,
  	saveProductionScheduleHistoryOnDynamoDBLoading: state => state.saveProductionScheduleHistoryOnDynamoDBLoading,
  	deletedProductionScheduleHistoryOnDynamoDB: state => state.deletedProductionScheduleHistoryOnDynamoDB,
	deleteProductionScheduleHistoryOnDynamoDBError: state => state.deleteProductionScheduleHistoryOnDynamoDBError,
  	deleteProductionScheduleHistoryOnDynamoDBLoading: state => state.deleteProductionScheduleHistoryOnDynamoDBLoading,
  	reloadProductionScheduleHistory: state => state.reloadProductionScheduleHistory,
	reloadProductionScheduleHistoryError: state => state.reloadProductionScheduleHistoryError,
  	reloadProductionScheduleHistoryLoading: state => state.reloadProductionScheduleHistoryLoading,
  	deletedProductionSchedule: state => state.deletedProductionSchedule,
	deleteProductionScheduleError: state => state.deleteProductionScheduleError,
  	deleteProductionScheduleLoading: state => state.deleteProductionScheduleLoading,
  	scheduleResult: state => state.scheduleResult,
	scheduleError: state => state.scheduleError,
  	scheduleLoading: state => state.scheduleLoading
}

const mutations = {
	[types.GET_PRODUCTION_SCHEDULE_DATA_REQUEST](state) {
		state.productionScheduleDataLoading = true
		state.productionScheduleDataError = ''
		state.productionScheduleData = {}
	},
	[types.GET_PRODUCTION_SCHEDULE_DATA_SUCCESS](state, productionScheduleData) {
		state.productionScheduleDataLoading = false
		state.productionScheduleDataError = ''
		state.productionScheduleData = productionScheduleData;
	},
	[types.GET_PRODUCTION_SCHEDULE_DATA_FAILURE](state, productionScheduleDataError) {
		state.productionScheduleDataLoading = false
		state.productionScheduleDataError = productionScheduleDataError
		state.productionScheduleData = {}
	},
	[types.SAVE_PRODUCTION_SCHEDULE_REQUEST](state) {
		state.saveProductionScheduleLoading = true
		state.saveProductionScheduleError = ''
		state.savedProductionSchedule = ''
	},
	[types.SAVE_PRODUCTION_SCHEDULE_SUCCESS](state, savedProductionSchedule) {
		state.saveProductionScheduleLoading = false
		state.saveProductionScheduleError = ''
		state.savedProductionSchedule = savedProductionSchedule;
	},
	[types.SAVE_PRODUCTION_SCHEDULE_FAILURE](state, saveProductionScheduleError) {
		state.saveProductionScheduleLoading = false
		state.saveProductionScheduleError = saveProductionScheduleError
		state.savedProductionSchedule = ''
	},
	[types.GET_PRODUCTION_SCHEDULE_HISTORY_REQUEST](state) {
		state.getProductionScheduleHistoryLoading = true
		state.getProductionScheduleHistoryError = {}
		state.productionScheduleHistory = []
	},
	[types.GET_PRODUCTION_SCHEDULE_HISTORY_SUCCESS](state, productionScheduleHistory) {
		state.getProductionScheduleHistoryLoading = false
		state.getProductionScheduleHistoryError = {}
		state.productionScheduleHistory = productionScheduleHistory;
	},
	[types.GET_PRODUCTION_SCHEDULE_HISTORY_FAILURE](state, getProductionScheduleHistoryError) {
		state.getProductionScheduleHistoryLoading = false
		state.getProductionScheduleHistoryError = getProductionScheduleHistoryError
		state.productionScheduleHistory = []
	},
	[types.SAVE_PRODUCTION_SCHEDULE_HISTORY_ON_DYNAMO_DB_REQUEST](state) {
		state.saveProductionScheduleHistoryOnDynamoDBLoading = true
		state.saveProductionScheduleHistoryOnDynamoDBError = {}
		state.savedProductionScheduleHistoryOnDynamoDB = {}
	},
	[types.SAVE_PRODUCTION_SCHEDULE_HISTORY_ON_DYNAMO_DB_SUCCESS](state, savedProductionScheduleHistory) {
		state.saveProductionScheduleHistoryOnDynamoDBLoading = false
		state.saveProductionScheduleHistoryOnDynamoDBError = {}
		state.savedProductionScheduleHistoryOnDynamoDB = savedProductionScheduleHistory;
	},
	[types.SAVE_PRODUCTION_SCHEDULE_HISTORY_ON_DYNAMO_DB_FAILURE](state, saveProductionScheduleHistoryOnDynamoDBError) {
		state.saveProductionScheduleHistoryOnDynamoDBLoading = false
		state.saveProductionScheduleHistoryOnDynamoDBError = saveProductionScheduleHistoryOnDynamoDBError
		state.savedProductionScheduleHistoryOnDynamoDB = {}
	},
	[types.DELETE_PRODUCTION_SCHEDULE_HISTORY_ON_DYNAMO_DB_REQUEST](state) {
		state.deleteProductionScheduleHistoryOnDynamoDBLoading = true
		state.deleteProductionScheduleHistoryOnDynamoDBError = {}
		state.deletedProductionScheduleHistoryOnDynamoDB = {}
	},
	[types.DELETE_PRODUCTION_SCHEDULE_HISTORY_ON_DYNAMO_DB_SUCCESS](state, deletedProductionScheduleHistory) {
		state.deleteProductionScheduleHistoryOnDynamoDBLoading = false
		state.deleteProductionScheduleHistoryOnDynamoDBError = {}
		state.deletedProductionScheduleHistoryOnDynamoDB = deletedProductionScheduleHistory;
	},
	[types.DELETE_PRODUCTION_SCHEDULE_HISTORY_ON_DYNAMO_DB_FAILURE](state, deleteProductionScheduleHistoryOnDynamoDBError) {
		state.deleteProductionScheduleHistoryOnDynamoDBLoading = false
		state.deleteProductionScheduleHistoryOnDynamoDBError = deleteProductionScheduleHistoryOnDynamoDBError
		state.deletedProductionScheduleHistoryOnDynamoDB = {}
	},
	[types.RELOAD_PRODUCTION_SCHEDULE_HISTORY_REQUEST](state) {
		state.reloadProductionScheduleHistoryLoading = true
		state.reloadProductionScheduleHistoryError = {}
		state.reloadProductionScheduleHistory = {}
	},
	[types.RELOAD_PRODUCTION_SCHEDULE_HISTORY_SUCCESS](state, reloadProductionScheduleHistory) {
		state.reloadProductionScheduleHistoryLoading = false
		state.reloadProductionScheduleHistoryError = {}
		state.reloadProductionScheduleHistory = reloadProductionScheduleHistory;
	},
	[types.RELOAD_PRODUCTION_SCHEDULE_HISTORY_FAILURE](state, reloadProductionScheduleHistoryError) {
		state.reloadProductionScheduleHistoryLoading = false
		state.reloadProductionScheduleHistoryError = reloadProductionScheduleHistoryError
		state.reloadProductionScheduleHistory = {}
	},
	[types.DELETE_PRODUCTION_SCHEDULE_REQUEST](state) {
		state.deleteProductionScheduleLoading = true
		state.deleteProductionScheduleError = {}
		state.deletedProductionSchedule = {}
	},
	[types.DELETE_PRODUCTION_SCHEDULE_SUCCESS](state, deletedProductionSchedule) {
		state.deleteProductionScheduleLoading = false
		state.deleteProductionScheduleError = {}
		state.deletedProductionSchedule = deletedProductionSchedule;
	},
	[types.DELETE_PRODUCTION_SCHEDULE_FAILURE](state, deleteProductionScheduleError) {
		state.deleteProductionScheduleLoading = false
		state.deleteProductionScheduleError = deleteProductionScheduleError
		state.deletedProductionSchedule = {}
	},
	[types.SCHEDULE_REQUEST](state) {
		state.scheduleLoading = true
		state.scheduleError = {}
		state.scheduleResult = {}
	},
	[types.SCHEDULE_SUCCESS](state, scheduleResult) {
		state.scheduleLoading = false
		state.scheduleError = {}
		state.scheduleResult = scheduleResult;
	},
	[types.SCHEDULE_FAILURE](state, scheduleError) {
		state.scheduleLoading = false
		state.scheduleError = scheduleError
		state.scheduleResult = {}
	}

}

export default {
	state,
	getters,
	actions,
	mutations
}
